import type { Movie } from '@/mocks/movies';
import SectionHeading from '@/components/base/SectionHeading';
import MovieCard from '@/components/base/MovieCard';

type PopularMoviesProps = {
  items: Movie[];
};

export default function PopularMovies({ items }: PopularMoviesProps) {
  return (
    <section className="w-full bg-background-100 px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        title="热门电影推荐"
        subtitle="综合热度与口碑，为你精选当下最值得一看的影片"
        moreTo="/movies/popular"
        moreLabel="全部热门影片"
      />
      {items.length === 0 ? (
        <p className="rounded-lg border border-dashed border-background-300 bg-background-50 py-12 text-center text-sm text-foreground-500">
          暂无相关内容，敬请期待
        </p>
      ) : (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {items.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      )}
    </section>
  );
}